import { Routes, Route } from 'react-router-dom';
import { FormContextProvider } from 'contexts/FormContext';
import GbMigrationFormPage from './migration-form';

export default function GbMigrationRoutes() {
  return (
    <FormContextProvider market="gb">
      <Routes>
        <Route path="migration-form" element={<GbMigrationFormPage />} />
      </Routes>
    </FormContextProvider>
  );
}
